import { Currency } from 'core/payments/entities';

export enum SnapchatEventNames {
  PAGE_VIEW = 'PAGE_VIEW',
  SIGN_UP = 'SIGN_UP',
  VIEW_CONTENT = 'VIEW_CONTENT',
  ADD_CART = 'ADD_CART',
  START_CHECKOUT = 'START_CHECKOUT',
  PURCHASE = 'PURCHASE',
}

export type SnapchatViewContentParams = {
  items: Array<{ productId: string; price: number }>;
  currency: Currency;
  nebulaId: string;
};

export type SnapchatAddToCartParams = {
  price: number;
  productId: string;
  currency: Currency;
  nebulaId: string;
};

export type SnapchatStartCheckoutParams = {
  price: number;
  productId: string;
  currency: Currency;
  nebulaId: string;
};

export type SnapchatPurchaseParams = {
  price: number;
  ltvPredict: number;
  paymentId: string;
  currency: Currency;
  productId: string;
};

export type SnapchatMethods = {
  init: (pixelId: string, userData?: { user_email: string }) => void;
  track: (eventName: SnapchatEventNames, params?: Record<string, unknown>) => void;
};
